import { observable, action, runInAction } from 'mobx'
import API from '@api/hotel/order'
import { hashHistory } from 'react-router'

class Store {
  @observable loading = true
  @observable status_no = ''
  @observable tabkey = 'all'

  @observable
  form = {
    status: '',
    phone: '',
    name: '',
    order_no: '',
    start_wedding: '',
    end_wedding: '',
    start_time: '',
    end_time: ''
  }

  @action
  setStatus = e => {
    this.status_no = e
    this.form.status = e
    this.tabkey = e
    this.callback(e)
  }

  @observable dataLoad = ''
  @observable dataOk = ''
  @observable dataNot = ''
  @observable list = []

  @action
  callback = key => {
    this.loading = true
    this.tabkey = key
    this.form.status = key
    this.reList(key)
    hashHistory.replace('/localMerchant/orderFeedback?status=' + key)
  }

  @action
  reList = key => {
    if (key == 'all') {
      key = ''
    }
    this.OrderFB_list('status=' + key + '&per_page=10')
  }

  @action
  paging = type => ({ current }) => {
    this['pagination_' + type].current = current
    let _type = type
    if (_type == 'all') {
      _type = ''
    }
    this.OrderFB_list('status=' + _type + '&page=' + current + '&per_page=10')
  }

  @action
  dataLoading = async params => {
    let paramsCont = this.getParams(params)
    let _status = paramsCont['status']
    let {
      data: { total_count }
    } = await API.OrderFB_list(params)
    runInAction('loading', () => {
      switch (_status) {
        case '0':
          this.dataLoad = total_count
          break
        case '1':
          this.dataOk = total_count
          break
        case '2':
          this.dataNot = total_count
          break
      }
    })
  }

  @action
  OrderFB_list = async params => {
    let paramsCont = this.getParams(params)
    let _status = paramsCont['status']
    let _page = paramsCont['page']

    let {
      data: { list, total_count }
    } = await API.OrderFB_list(params)
    runInAction('order', () => {
      this.loading = false
      switch (_status) {
        case '0':
          this.dataLoad = total_count
          break
        case '1':
          this.dataOk = total_count
          break
        case '2':
          this.dataNot = total_count
          break
      }
      this.list = list
      this['pagination_' + _status].total = +total_count
      this['pagination_' + _status].current = parseInt(_page)
    })
  }

  //全部订单
  @observable
  pagination_ = {
    showQuickJumper: true,
    pageSize: 10,
    total: 0,
    current: 1
  }

  //确认中
  @observable
  pagination_0 = {
    showQuickJumper: true,
    pageSize: 10,
    total: 0,
    current: 1
  }

  //通过
  @observable
  pagination_1 = {
    showQuickJumper: true,
    pageSize: 10,
    total: 0,
    current: 1
  }

  //不通过
  @observable
  pagination_2 = {
    showQuickJumper: true,
    pageSize: 10,
    total: 0,
    current: 1
  }

  //search
  @observable wedding_time
  @observable sub_time

  @action
  getWtime = (date, dateString) => {
    this.wedding_time = date
  }
  @action
  getStime = (date, dateString) => {
    this.sub_time = date
  }

  @action
  getPhone = e => {
    this.form.phone = e.target.value
  }

  @action
  getName = e => {
    this.form.name = e.target.value
  }

  @action
  getOrderNo = e => {
    this.form.order_no = e.target.value
  }

  @action
  sendSearch = () => {
    this.loading = true
    if (this.wedding_time) {
      this.form.start_wedding = this.wedding_time[0].format('YYYY-MM-DD')
      this.form.end_wedding = this.wedding_time[1].format('YYYY-MM-DD')
    }
    if (this.sub_time) {
      this.form.start_time = this.sub_time[0].format('YYYY-MM-DD')
      this.form.end_time = this.sub_time[1].format('YYYY-MM-DD')
    }
    let _status = this.form.status
    if (_status == 'all') {
      _status = ''
    }
    this.OrderFB_list(
      'status=' +
        _status +
        '&order_no=' +
        this.form.order_no +
        '&phone=' +
        this.form.phone +
        '&name=' +
        this.form.name +
        '&start_time=' +
        this.form.start_time +
        '&start_wedding=' +
        this.form.start_wedding +
        '&end_time=' +
        this.form.end_time +
        '&end_wedding=' +
        this.form.end_wedding +
        '&per_page=10'
    )
  }

  @action
  sendRest = () => {
    this.loading = true
    this.form.phone = ''
    this.form.name = ''
    this.form.order_no = ''
    this.form.start_wedding = ''
    this.form.end_wedding = ''
    this.wedding_time = null
    this.sub_time = null
    let _status = this.form.status
    if (_status == 'all') {
      _status = ''
    }
    this.OrderFB_list('status=' + _status + '&per_page=10')
  }

  @action
  getParams = str => {
    let getParams = {}
    const arr = str.split('&')
    arr.forEach(el => {
      const ret = el.split('=')
      getParams[ret[0]] = ret[1]
    })
    return getParams
  }
}
export default new Store()
